"use client";

import React from "react";
import { StyledSection } from "./widgetDefinition.styles";

interface IWidgetDefinitionProps {
  text: string | string[];
}

export const WidgetDefinition = ({ text }: IWidgetDefinitionProps) => {
  const paragraphs = Array.isArray(text) ? text : [text];
  return (
    <StyledSection>
      <div className="inner">
        {paragraphs.map((p, i) => (
          <p key={i}>{p}</p>
        ))}
      </div>
    </StyledSection>
  );
};
